
// components imports
import { AtualizarMulta, GerarDoc, SalvarMulta } from "services/CallAPIs"
import { autoFill, dropdownsAreValid, getFormData } from "services/FormFunctions"
import { userHasAccess, userLogado } from "services/LoginFunctions"

import { criarDocBodyBD } from "models/BodyDocumentosBD"

import { ROLE } from "constants/userRoles"

export function urlVoltar(linkNovaCalcularTaxa, idServico) { return linkNovaCalcularTaxa + idServico }
export function temTestemunhas(idServico) { return idServico === "AutoDeInfracao" }
export function podeTerAutoEmbargo(idServico) { return idServico !== "ObraIniciadaSemLicenca" }
export function modoEditar(docData) { return !!docData }

export function autoActivateSwitches(docData, setTemProcesso, setTemNotificacao, setTemAutoDeEmbargo, setTemAutoDeInfracao)
{
    if (!modoEditar(docData)) { return }

    console.log("auto activating switches")
    setTemProcesso(!!docData.numProc)
    setTemNotificacao(!!docData.numNotificacao)
    setTemAutoDeEmbargo(!!docData.numAutoEmbargo)
    setTemAutoDeInfracao(!!docData.numAutoInfracao)
}

export function autoFillMulta(docData)
{
    if (!docData) { console.log("Aviso: Tentando preencher formulário da multa sem dados da multa") ; return }

    autoFill(docData)
}
export function onChangeCPFCNPJ(setSwitchCNPJ)
{
    const switchCNPJField = document.getElementsByName("switchCNPJ")[0]
    setSwitchCNPJ(switchCNPJField === undefined ? false : switchCNPJField.checked)
}

export async function handleSubmit(event, setValidated, setShowAlertInputsNotValid, setLoading, setShowSuccessDocumentoGerado, setShowErrorMessage,
                                    docData, idServico, tipoServico, taxInputs, taxResults)
{
    const form = event.currentTarget
    const editar = modoEditar(docData)
    event.preventDefault()
    // TODO paginação da tabela de multas
    // TODO filtros da tabela de multas
    if (!form.checkValidity() | !dropdownsAreValid())
    {
        event.stopPropagation()
        setValidated(false)
        setShowAlertInputsNotValid(true)

        return
    }

    if (!userLogado)
    {
        alert("É preciso estar logado para gerar documentos! Você pode fazer login no botão Entrar na parte superior da página.")   
        return
    }
    if (!userHasAccess(ROLE.ANALISTA))
    {
        alert("É preciso estar ter permissão de analista para gerar documentos! Peça a permissão ao seu gestor.")   
        return
    }

    setValidated(true)
    let formData = getFormData(form)
    setLoading(true)

    const body = criarDocBodyBD("Multa", taxInputs, formData, taxResults, idServico, "")

    if (!editar)
    { 
        try
        {
            await SalvarMulta(body)
        }
        catch
        {
            alert("Erro ao tentar salvar multa no banco de dados")
        }
    }
    else
    {
        try
        {
            await AtualizarMulta(docData.id, body)
        }
        catch
        {
            alert("Erro ao tentar atualizar multa no banco de dados")
        }
    }
    
    await GerarDoc(body, tipoServico, formData.numProc, formData.anoProc, true, {success: setShowSuccessDocumentoGerado, error: setShowErrorMessage})

    setLoading(false)
}